import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useImmer } from 'use-immer'
import Rodal from 'rodal'
import { useMediaQuery } from 'react-responsive'

import {
    fetchUserProfile,
    generateUserAPIToken,
    resetGenerateAPITokenState,
} from '../../store/user/userAction'
import EditProfile from './editProfile'
import ShowTokenCredentials from './showTokenCreds'
import ShowUserAccessKeysList from './showUserAccessKeysList'
import Spinner from 'components/common/Spinner'
import Image from 'components/common/ImageLoader'
import Button from 'components/common/Button'
import WorldIcon from 'assets/language.svg'
import SettingsIcon from 'assets/settings.svg'
import ContactIcon from 'assets/contact-book.svg'
import PencilIcon from 'assets/pencil.svg'
import AddIcon from 'assets/add.svg'
import './index.css'

const UserProfilePage = (props) => {
    const isDesktop = useMediaQuery({ minWidth: 1025 })
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 })
    const isMobile = useMediaQuery({ maxWidth: 767 })

    const dispatch = useDispatch()
    const user = useSelector((state) => state.user.profile)
    const generateUserAPITokenState = useSelector(
        (state) => state.user.generateUserAPIToken
    )

    const [state, setState] = useImmer({
        toggleEdit: false,
        toggleTokenCredModal: false,
    })

    useEffect(() => {
        dispatch(fetchUserProfile())
    }, [])

    if (user.loading) {
        return (
            <div className="mx-4 my-4 px-6 py-10 flex items-center justify-center">
                <Spinner loaderSize="lg" />
            </div>
        )
    }

    if (user.error) {
        return (
            <div className="mx-4 my-4 p-6">
                Something went wrong. Please check again later
            </div>
        )
    }

    //   if (generateUserAPITokenState.success) {
    //     setState((draft) => {
    //       draft.toggleTokenCredModal = true;
    //     });
    //   }

    const retreiveAPIkey = () => {
        console.log('user?.data?.creds', user?.data?.creds)
        return user?.data?.creds?.find((item) => item.active === true)
    }

    const renderAccessKeys = () => {}

    return (
        <div className="mx-1 sm:mx-4 my-4">
            <section class="text-gray-700 body-font">
                <div class="container px-1 sm:px-5 pt-16 pb-8 mx-auto flex flex-wrap">
                    <div class="sm:text-xl text-lg text-gray-900 mb-2 md:w-2/5 flex items-center sm:border-r-2 sm:border-gray-300">
                        <div className="flex flex-wrap items-center justify-center sm:justify-start">
                            <div className="profile-img-container py-2 w-48 h-48">
                                <img
                                    src={
                                        user?.data?.image
                                            ? user?.data?.image
                                            : 'https://firstsiteguide.com/wp-content/uploads/2017/07/what-is-gravatar-1-1-700x313-1-640x400.png'
                                    }
                                    class="max-w-none opacity-05 w-48 h-48 rounded-50-percent inline-block border-1 border-gray-200 bg-gray-100 object-cover"
                                />
                            </div>
                            <div className="ml-4">
                                <div className="font-bold text-4xl">
                                    {user?.data?.first_name + ' ' ||
                                        'Intrigue user'}{' '}
                                    {user?.data?.last_name || ''}
                                </div>
                                <div className="text-base text-gray-600">
                                    {user?.data?.email}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md:w-3/5 md:pl-6">
                        <div className="mt-2">
                            {state.toggleEdit ? (
                                <EditProfile
                                    user={user?.data}
                                    closeEdit={() => {
                                        setState((draft) => {
                                            draft.toggleEdit = false
                                        })
                                    }}
                                />
                            ) : (
                                <React.Fragment>
                                    {' '}
                                    <div className="text-gray-900 font-medium title-font text-2xl mb-2 flex items-center justify-between bg-gray-200 px-2 py-2 rounded-md">
                                        <div className="flex items-center ">
                                            <span className="pr-2">
                                                {' '}
                                                Personal Details{' '}
                                            </span>
                                            <Image
                                                src={ContactIcon}
                                                width={30}
                                                height={30}
                                            />
                                        </div>
                                        <div className="">
                                            <Button
                                                intent="primary"
                                                onClick={() => {
                                                    setState((draft) => {
                                                        draft.toggleEdit = true
                                                    })
                                                }}
                                                customClass="px-2 py-2 "
                                            >
                                                <Image
                                                    src={PencilIcon}
                                                    width={25}
                                                    height={25}
                                                />
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="px-2 py-2">
                                        <p class="leading-relaxed text-lg">
                                            First Name:{' '}
                                            {user?.data?.first_name ||
                                                'Information not available'}
                                        </p>
                                        <p class="leading-relaxed text-lg">
                                            Last Name:{' '}
                                            {user?.data?.last_name ||
                                                'Information not available'}
                                        </p>
                                        <p class="leading-relaxed text-lg">
                                            Email:{' '}
                                            {user?.data?.email ||
                                                'Information not available'}
                                        </p>
                                        <p class="leading-relaxed text-lg">
                                            Username:{' '}
                                            {user?.data?.username ||
                                                'Information not available'}
                                        </p>
                                        <p class="leading-relaxed text-lg">
                                            Google Auth:{' '}
                                            <code className="bg-yellow-200">
                                                {user?.data?.google ||
                                                    'Information not available'}
                                            </code>
                                        </p>
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="mt-20">
                            <h1 className="text-gray-900 font-medium title-font text-2xl mb-2 flex items-center bg-gray-200 px-2 py-2 rounded-md">
                                <span className="pr-2"> Organization </span>
                                <Image src={WorldIcon} width={30} height={30} />
                            </h1>
                            <div className="px-2 py-2">
                                <p class="leading-relaxed text-lg">
                                    Organization Name: Jonathan
                                </p>
                                <p class="leading-relaxed text-lg">
                                    Plan: Provider plan{' '}
                                    <a className="text-primary-500 cursor-pointer">
                                        [upgrade]
                                    </a>
                                </p>
                                <p class="leading-relaxed text-lg">
                                    Trial ends at: 2020-22-22 12:02:02 UTC
                                </p>
                                <p class="leading-relaxed text-lg">
                                    Paid ends at: 2020-22-22 12:02:02 UTC
                                </p>
                                <p class="leading-relaxed text-lg">
                                    Collection Limits : 3/100
                                </p>
                                <p class="leading-relaxed text-lg">
                                    {' '}
                                    Global Collection Limits : 3/100
                                </p>
                            </div>
                        </div>
                        <div className="mt-20">
                            <div className="text-gray-900  mb-2 flex items-center justify-between bg-gray-200 px-2 py-2 rounded-md">
                                <div>
                                    <div className="flex items-center font-medium title-font text-2xl">
                                        <span className="pr-2">
                                            {' '}
                                            API Access{' '}
                                        </span>
                                        <Image
                                            src={SettingsIcon}
                                            width={30}
                                            height={30}
                                        />
                                    </div>
                                </div>

                                <div title="Generate new API key ">
                                    {' '}
                                    <Button
                                        intent="primary"
                                        customClass="px-2 py-2 "
                                        loading={
                                            generateUserAPITokenState.loading
                                                ? true
                                                : false
                                        }
                                        // showSpinner={true}

                                        onClick={() => {
                                            dispatch(generateUserAPIToken())
                                        }}
                                    >
                                        <Image
                                            src={AddIcon}
                                            width={25}
                                            height={25}
                                        />
                                    </Button>
                                </div>
                            </div>
                            {/* <div className="px-2 py-2 float-left">
                Active Access Key :{' '}
                <span className="ml-2">
                  {retreiveAPIkey()?.access_key ||
                    'You currently do not have any access keys. Generate an API key to get started'}
                </span>
              </div> */}
                            {/* <div className="w-full">
                <Button
                  customClass="ml-2 bg-gray-700 hover:bg-gray-900 rounded-md text-white px-4 py-2"
                  intent="primary"
                  loading={generateUserAPITokenState.loading ? true : false}
                  showSpinner={true}
                  onClick={() => {
                    dispatch(generateUserAPIToken());
                  }}
                >
                  Generate New API key{' '}
                </Button>
              </div> */}
                            <div className="ml-2 mt-4 pt-2  ">
                                <span className="text-lg  ">
                                    List of active access keys
                                </span>
                                <div className="w-full">
                                    <ShowUserAccessKeysList
                                        accesskeys={user?.data?.creds}
                                        updateProfileData={() => {
                                            dispatch(fetchUserProfile())
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Rodal
                    className="rodal-sort-container"
                    visible={generateUserAPITokenState.success}
                    onClose={() => {
                        dispatch(resetGenerateAPITokenState())
                        dispatch(fetchUserProfile())
                    }}
                    customStyles={{
                        width: isMobile || isTablet ? '90%' : '37%',
                        height: isMobile || isTablet ? '450px' : '350px',
                    }}
                    closeMaskOnClick={true}
                    closeOnEsc={true}
                    animationType="enter"
                    showCloseButton={true}
                >
                    <ShowTokenCredentials />
                </Rodal>
            </section>
        </div>
    )
}

export default UserProfilePage
